module.exports = __webpack_public_path__ + "static/media/coloured-card-with-btn.c913d1fb.jpg";